import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadPurchaseIndentList = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.REQUEST_INDENT_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadPurchaseIndentNumber = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PURCHASE_INDENT_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadPurchaseDetail = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PURCHASE_GET_REQUEST_INDENT_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const IssuedIndentCRUD = async (api, payload) => {
    try {
        return await callApi(api, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

export const loadPurchaseReceivedReportItemTable = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.PURCHASED_RECEIVED_GET_TABLE_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, payload);

    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};


export const loadPurchaseInspectionList = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.PURCHASE_INSPECTION_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

export const getInspectionDetailsById = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.PURCHASE_INSPECTION_LIST_BY_ID, 'POST', { 'Content-Type': 'application/json' }, payload);

    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

export const loadPurchaseReceivedList = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.PURCHASE_RECEIVE_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
}

export const loadPurchaseOrderList = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PURCHASE_ORDER_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
}

